/**
 * SUSANNO DataLayer — GA4 + Meta Pixel Event Tracking
 * Fires: view_item, add_to_cart, view_cart, begin_checkout
 * Purchase event → via Shopify Custom Pixel (Admin → Settings → Customer Events)
 */
(function() {
  window.dataLayer = window.dataLayer || [];

  // ============ SHOPIFY CUSTOM PIXEL BRIDGE (purchase, checkout, product_viewed) ============
  window.addEventListener('message', function(e) {
    if (!e.data || e.data.source !== 'susanno-pixel') return;
    if (!e.data.event || !e.data.ecommerce) return;
    window.dataLayer.push({
      event: e.data.event,
      ecommerce: e.data.ecommerce
    });
  });

  // ============ ADD TO CART ============
  function trackAddToCart(productData) {
    window.dataLayer.push({
      event: 'add_to_cart',
      ecommerce: {
        currency: productData.currency || 'EUR',
        value: productData.value || 0,
        items: productData.items || []
      }
    });
  }

  // Listen to all add-to-cart forms (Shopify Theme standard form)
  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (!form.matches('form[action*="/cart/add"]')) return;

    var formData = new FormData(form);
    var variantId = formData.get('id');
    var quantity = parseInt(formData.get('quantity') || '1');

    // Try to get product data from window variable (set by product template)
    var productData = window.SUSANNO_CURRENT_PRODUCT;
    if (!productData) return;

    var variant = (productData.variants || []).find(function(v) { return String(v.id) === String(variantId); });
    var price = variant ? variant.price / 100 : productData.price / 100;

    trackAddToCart({
      currency: productData.currency || 'EUR',
      value: price * quantity,
      items: [{
        item_id: String(productData.id),
        item_name: productData.title,
        item_brand: 'SUSANNO',
        item_category: productData.type || '',
        item_variant: variant ? variant.title : '',
        price: price,
        quantity: quantity
      }]
    });
  });

  // Also listen to AJAX cart additions (fetch to /cart/add.js)
  var origFetch = window.fetch;
  if (origFetch) {
    window.fetch = function(resource, options) {
      var url = typeof resource === 'string' ? resource : resource.url;
      var isAddToCart = url && url.indexOf('/cart/add') !== -1;
      return origFetch.apply(this, arguments).then(function(response) {
        if (isAddToCart && response.ok) {
          var clone = response.clone();
          clone.json().then(function(data) {
            // Shopify returns the added item
            var item = data.items ? data.items[0] : data;
            if (!item || !item.product_id) return;
            trackAddToCart({
              currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'EUR',
              value: (item.final_line_price || item.line_price || item.price) / 100,
              items: [{
                item_id: String(item.product_id),
                item_name: item.product_title || item.title,
                item_brand: 'SUSANNO',
                item_category: item.product_type || '',
                item_variant: item.variant_title || '',
                price: item.final_price / 100,
                quantity: item.quantity
              }]
            });
          }).catch(function() {});
        }
        return response;
      });
    };
  }

  // ============ BEGIN CHECKOUT ============
  document.addEventListener('click', function(e) {
    var t = e.target;
    // Shopify checkout buttons / cart checkout forms
    var isCheckoutBtn = t.matches('[name="checkout"], [name="goto_pay"], button[name="checkout"], a[href="/checkout"]') ||
                       t.closest('[name="checkout"], [name="goto_pay"]');
    if (!isCheckoutBtn) return;
    if (!window.SUSANNO_CART_DATA) return;
    window.dataLayer.push({
      event: 'begin_checkout',
      ecommerce: {
        currency: window.SUSANNO_CART_DATA.currency,
        value: window.SUSANNO_CART_DATA.value,
        items: window.SUSANNO_CART_DATA.items
      }
    });
  });
})();
